import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cryptoApiHeaders = {
  "x-rapidapi-host": "coinranking1.p.rapidapi.com",
  "x-rapidapi-key": "6799a95bc9msh6f5ff7eaa9e9796p17f36fjsnd33ca68ec904",
};

const baseUrl = "https://coinranking1.p.rapidapi.com";

const createReq = (url) => ({ url, headers: cryptoApiHeaders });

export const rapidCryptoApi = createApi({
  reducerPath: "rapidCryptoApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getRapidCrypto: builder.query({
      query: (count) => {
        return {
          url: `/coins?limit=${count}`,
          headers: cryptoApiHeaders,
        };
      },
    }),
    getRapidCryptoHistory: builder.query({
      query: ({ coinId, timeperiod }) => {
        return {
          url: `https://coinranking1.p.rapidapi.com/coin/${coinId}/history`,
          params: { timePeriod: timeperiod },
          headers: cryptoApiHeaders,
        };
      },
    }),
  }),
});

export const { useGetRapidCryptoQuery, useGetRapidCryptoHistoryQuery } =
  rapidCryptoApi;
